"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @description Metoda porównująca typ danego obiektu z zadanym
 * @function
 *
 * @param {object} what
 * @param {String} type poprawny string reprezentujący typ
 *
 * @property {function} u sprawdza czy dany obiekt jest typu undefined
 * @property {function} s sprawdza czy dany obiekt jest typu string
 * @property {function} b sprawdza czy dany obiekt jest typu boolean
 * @property {function} n sprawdza czy dany obiekt jest typu number
 * @property {function} o sprawdza czy dany obiekt jest typu object
 * @property {function} f sprawdza czy dany obiekt jest typu function
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
var isOfType = function (what, type) { return (typeof what) === type; }; // eslint-disable-line valid-typeof
['undefined', 'string', 'boolean', 'number', 'object', 'function'].forEach(function (type) {
    isOfType[type[0]] = function (what) { return isOfType(what, type); };
});
exports.default = isOfType;
